import React, { useState } from "react";
import { Loader2, Check, Scale } from "lucide-react";
import { toast } from "sonner";
import { apiClient } from "@/lib/apiClient";

const chf = (v) => `CHF ${Number(v || 0).toLocaleString("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Ziffer 415 automatisch (Pauschal-Kürzungsschlüssel): Anzeige + Buchung per Klick. */
export function MixedUseCorrectionRow({ companyId, year, period, mixedUse, onChanged }) {
  const [busy, setBusy] = useState(false);
  if (!mixedUse?.key_percent) return null;
  const book = async () => {
    setBusy(true);
    try {
      const r = await apiClient.post(`/companies/${companyId}/vat/mixed-use-correction/book`, null, { params: { year, period } });
      toast.success(`${r.data.description}: ${chf(r.data.amount)} gebucht (${r.data.expense_account} an ${r.data.vat_account})`);
      onChanged?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Buchung fehlgeschlagen"); } finally { setBusy(false); }
  };
  return (
    <div className="mt-2 rounded border border-sky-200 bg-sky-50 p-2 text-[11px] text-sky-900" data-testid="mixed-use-row">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="inline-flex items-start gap-1.5">
          <Scale className="h-3.5 w-3.5 mt-0.5 shrink-0" />
          <div>
            <b>Ziffer 415 – Vorsteuerkorrektur gemischte Verwendung</b>{" "}
            {mixedUse.auto ? (
              <>automatisch: {chf(mixedUse.base)} Vorsteuer × <b>{mixedUse.key_percent} %</b> = <b data-testid="mixed-use-amount">{chf(mixedUse.amount)}</b></>
            ) : (
              <>Schlüssel {mixedUse.key_percent} % hinterlegt, Ziffer 415 ist für diese Periode <b>manuell</b> gesetzt (Anpassung hat Vorrang).</>
            )}
          </div>
        </div>
        {mixedUse.auto && (mixedUse.booked ? (
          <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-0.5 text-emerald-800" data-testid="mixed-use-booked"><Check className="h-3 w-3" />gebucht per {mixedUse.period_end?.split("-").reverse().join(".")}</span>
        ) : mixedUse.amount > 0 ? (
          <button type="button" onClick={book} disabled={busy} className="rounded-full bg-sky-700 px-3 py-1 font-medium text-white hover:bg-sky-800 disabled:opacity-50" data-testid="mixed-use-book">
            {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : "Korrektur buchen (Aufwand an Vorsteuer)"}
          </button>
        ) : <span className="text-sky-700/70">kein Betrag</span>)}
      </div>
    </div>
  );
}
